<div class="aviso-atividade-jornada" role="note">💡 Atenção: A inserção e edição de atividades somente estarão disponíveis enquanto a jornada estiver em aberto.</div>
